__webpack_require__.p = "/dev/vue3-class-migrator/";